// extracted by mini-css-extract-plugin
module.exports = {"root":"Formats_root__SlYlk"};